import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) { }

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}

@Pipe( {
  name: 'orderBy'
  } )
  export class OrderByPipe implements PipeTransform {
  transform( array: Array<any>, orderField: string, orderType: boolean ): Array<string> {
      array.sort( ( a: any, b: any ) => {
          const ae = a[ orderField ];
          const be = b[ orderField ];
          if ( ae === undefined && be === undefined ) return 0;
          if ( ae === undefined && be !== undefined ) return orderType ? 1 : -1;
          if ( ae !== undefined && be === undefined ) return orderType ? -1 : 1;
          if ( ae === be ) return 0;
          return orderType ? (ae.toString().toLowerCase() > be.toString().toLowerCase() ? -1 : 1) : (be.toString().toLowerCase() > ae.toString().toLowerCase() ? -1 : 1);
      } );
      return array;
    }
  }